<script setup lang="ts">
import { ref, computed } from 'vue'
import type { SurveyQuestion } from '@/types/surveyTypes'
import { Form } from 'vee-validate'
import StepperItemQuestion from '../StepperItemQuestion.vue'
import { useSurvey, AnswerTarget } from '@/composables/onlineSurvey/useSurvey'
import * as yup from 'yup'

const props = defineProps<{
  formConfig: SurveyQuestion[]
  message: string
}>()

const emit = defineEmits<{
  (e: 'formCompleted'): void
}>()

const { leadData, createFormValidationSchema } = useSurvey()
const formRef = ref()
const resultMessage = ref(props.message)

// Verwende die ausgelagerte Validierungslogik
const validationSchema = computed(() => {
  return createFormValidationSchema(props.formConfig)
})

const handleSubmit = async () => {
  if (!formRef.value) return

  const { valid, values } = await formRef.value.validate()
  console.log('Form validation:', { valid, values })

  if (valid) {
    // Emit Event mit den Formular-Daten
    emit('formCompleted')
  }
}
</script>

<template>
  <div class="stepper-item" v-if="!resultMessage">
    <Form
      ref="formRef"
      :validation-schema="validationSchema"
      @submit="handleSubmit"
      v-slot="{ isSubmitting }"
    >
      <h2 class="is-size-5 has-text-weight-semibold">
        Vielen Dank für Ihre Teilnahme! Bitte hinterlassen Sie uns noch Ihre Kontaktdaten:
      </h2>
      <div v-for="question in props.formConfig" :key="question.id">
        <StepperItemQuestion :question="question" :answerTarget="AnswerTarget.LEAD_DATA" />
      </div>

      <div class="is-flex is-justify-content-end mt-2">
        <button
          type="submit"
          class="button is-primary is-small"
          :class="{ 'is-loading': isSubmitting }"
          :disabled="isSubmitting"
        >
          Abschließen
        </button>
      </div>
    </Form>
  </div>
  <div v-else class="content">
    <div v-html="resultMessage"></div>
  </div>
</template>
